module.exports = __webpack_public_path__ + "static/media/mila.6860d4b3.png";